import cn from 'clsx';
import { PropsWithChildren } from 'react';

interface HeadingProps extends PropsWithChildren {
  readonly className?: string;
}

export function Heading({ children, className }: HeadingProps) {
  return (
    <h2
      className={cn(
        'font-heading break-words m-0 font-heading-weight text-xl',
        className,
      )}
    >
      {children}
    </h2>
  );
}
